module.exports = __webpack_public_path__ + "static/media/abmi.655f2d2b.webp";